module.exports = __webpack_public_path__ + "img/phone-bg.c39cba83.png";